import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { MatSnackBar } from "@angular/material/snack-bar";

@Component({
    selector: 'app-management',
    templateUrl: './management.component.html',
    styleUrls: ['./management.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ManagementComponent implements OnInit {

  constructor(
    private router: Router,
    public snackBar: MatSnackBar,
  ) {}

  ngOnInit(): void {
  }

  reDirectUrl() {
    this.router.navigate(['dashboard']);
  }
}
